import { createContext, useState, ReactNode, useContext } from "react";
import { Conversation, Message } from "../types";

interface ConversationContextType {
  conversationData: Conversation | null;
  conversationsData: Conversation[];
  message: Message[];
  setConversation: (conversation: Conversation | null) => void;
  setConversations: (conversations: Conversation[]) => void;
  setMessage: (messages: Message[]) => void;
}

export const ConversationContext = createContext<
  ConversationContextType | undefined
>(undefined);

export function ConversationProvider({ children }: { children: ReactNode }) {
  const [conversationData, setConversationData] = useState<Conversation | null>(
    null
  );
  const [conversationsData, setConversationsData] = useState<Conversation[]>(
    []
  );
  const [message, setMessageData] = useState<Message[]>([]);

  function setConversation(conversation: Conversation | null) {
    setConversationData(conversation);
  }

  function setConversations(conversations: Conversation[]) {
    setConversationsData(conversations);
  }

  function setMessage(messages: Message[]) {
    setMessageData(messages);
  }

  return (
    <ConversationContext.Provider
      value={{
        conversationData,
        conversationsData,
        message,
        setConversation,
        setConversations,
        setMessage,
      }}
    >
      {children}
    </ConversationContext.Provider>
  );
}

export function useConversationContext() {
  const context = useContext(ConversationContext);
  if (context === undefined) {
    throw new Error(
      "useConversationContext must be used within a ConversationProvider"
    );
  }
  return context;
}
